<template>
    <Page
        :heading="$t('login.heading').toString()"
        :text="$t('login.text').toString()"
    >
        <LoginForm @authenticated="handleAuthenticated" />
        <div slot="footer">
            <p class="max-w mt-8 text-center text-slate-600">
                {{ $t("login.register.text") }}
                <router-link
                    :to="{ name: 'register' }"
                    class="text-base font-medium text-indigo-600"
                    >{{ $t("login.register.link") }}</router-link
                >
            </p>
        </div>
    </Page>
</template>

<script>
import Page from "@/components/layout/Page";
import LoginForm from "@/components/forms/LoginForm";
import { redirectTo } from "@/router";

export default {
    name: "LoginPage",
    components: { Page, LoginForm },
    methods: {
        handleAuthenticated() {
            redirectTo("dashboard.overview");
        },
    },
};
</script>
